// react doc card title functional component

export default function DocCardTitle(props) {
    return <div className="doc-card-title">
        {props.children}
    </div>
}